import React from "react";
import {Draggable, Droppable} from "@hello-pangea/dnd";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import {usePermissions} from "../../../../contexts/permissions";
import {useShopping} from "../../../../contexts/shopping";
import {getImage} from "../CartItemFields";

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "",
  padding: 4,
});

export default function DroppableItem({ isDragging, item, index }) {
  const { user } = usePermissions();
  const { inventoryAssets } = useShopping();
  const wizardMode = user.company?.settings?.wizard_mode;
  const noDeliveryLocation = user.company?.settings?.delivery_location_modal;
  const [location, items] = item;
  const locationLabel = noDeliveryLocation === false ? null : (wizardMode ? "Start location" : "Delivery Location");

  return (
    <Box display="flex" my={1} border={`1px solid ${isDragging ? "#3949ab" : "#3f51b5"}`}>
      <Box display="flex" flexGrow={1} p={1} flexDirection={{ xs: "column", sm: "row" }}>
        <Box minWidth={115} pr={1}>
          <Typography color="textPrimary">
            {index === 0 ? locationLabel : `Stop ${index + 1}`}:
          </Typography>
        </Box>
        <Box flexGrow={1}>
          <Typography color="textSecondary">{location}</Typography>
          <Droppable droppableId={`droppable${location}`} type={`${index}`}>
            {(provided, snapshot) => (
              <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                {items.map((v, i) => {
                  const asset = inventoryAssets[v.assetId];
                  if (!asset) return null;
                  const photo = getImage(asset);
                  return (
                    <Draggable key={`${index}${i}`} draggableId={`${index}${i}`} index={i}>
                      {(provided, snapshot) => (
                        <Box
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          mt={1}
                          border={`1px solid ${isDragging ? "#3949ab" : "#d5d5d5"}`}
                          bgcolor="white"
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            px={1}
                            py={0.5}
                            {...provided.dragHandleProps}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              boxSizing="content-box"
                              overflow="hidden"
                              width={90}
                              height={60}
                              p={0.5}
                              mr={1}
                              borderRadius="4px"
                              bgcolor="#f4f6f8"
                              style={{
                                backgroundImage: photo ? `url(${photo})` : undefined,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                                backgroundPosition: "center",
                              }}
                            >
                              {photo ? (
                                <img style={{ maxHeight: 60 }} src={photo} alt="" />
                              ) : (
                                <span>No image</span>
                              )}
                            </Box>
                            <Box>
                              <Typography color="textSecondary">{asset.description}</Typography>
                              <Box display="flex">
                                <Box display="flex" mr={1.5}>
                                  <Typography color="textSecondary">
                                    Quantity: {v.quantity}
                                  </Typography>
                                </Box>
                                {v.building && (
                                  <Box display="flex" mr={1.5}>
                                    <Typography color="textSecondary">
                                      Building: {v.building}
                                    </Typography>
                                  </Box>
                                )}
                                {v.room && (
                                  <Box display="flex">
                                    <Typography color="textSecondary">Room #: {v.room}</Typography>
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </Box>
      </Box>
    </Box>
  );
}
